module.exports = __webpack_public_path__ + "static/media/img-04.37cb2115.jpg";